import { Site } from '@/true-fsd/data/advertiser-account'
import { siteMethods } from '@synapex/shared2/entities'
import { coerceUrlOrThrow } from '@synapex/tools/utils'
import { makeReducer, useParsedInput } from '../parsedInput'

type Ctx = Pick<Site, 'hostname' | 'pathname'> & {
    // erid?: string
}

export const makeErrorMessage = (site: Pick<Site, 'hostname' | 'pathname'>) => {
    return `Ссылка должна быть корректной и указывать на https://${siteMethods.getTitleString(site)}`
}

type ParsedValue = URLSearchParams

const mainUrlReducer = makeReducer<ParsedValue, Ctx>({
    parse: (site, input) => {
        if (URL.canParse(input)) {
            const url = new URL(input)
            url.searchParams.delete('erid')
            if (siteMethods.isEqual(site, url)) {
                return url.searchParams
            }
        }

        throw new Error(makeErrorMessage(site))
    },
    stringify: ({ hostname, pathname }, value) => {
        const url = coerceUrlOrThrow(
            siteMethods.getTitleString({ hostname, pathname })
        )

        const newValue = new URLSearchParams(value)
        newValue.delete('erid')
        url.search = decodeURIComponent(newValue.toString())

        return url.href
    },
})

export const useMainUrlInput = (
    ctx: Ctx,
    initialParsedValue: ParsedValue | null
) => {
    const { onChangeParsedValue, parsedValue, onNormalize, ...pi } =
        useParsedInput({
            ...mainUrlReducer,
            ctx,
            initialParsedValue,
        })

    return {
        ...pi,
        onApply: onNormalize,
        onChangeParsedValue,
        parsedValue,
    }
}
export type UseMainUrlInput = ReturnType<typeof useMainUrlInput>
